import "./MHMPressRelease.scss";

export default function DisplayAppAnnouncement() {
  const sharer = window.location.href;

  function sendMail() {
    const send = "mailto:?subject=" + encodeURIComponent("Introducing MustHaveMenus Display") + "&body=" + encodeURIComponent("Check out this article! " + sharer);
    window.location.href = send;
  }
    
  return (
    <main className="toast-integration-announcement">
      <section className="one">
        <div className="content">
          <div className="breadcrumb">
            <a href="/content/press">Press</a>
            &nbsp;&nbsp;&gt;&nbsp;&nbsp;
            <b>Introducing MustHaveMenus Display</b>
          </div>
        </div>
      </section>

      <section className="two">
        <div className="content">
          <div className="header">
            <div className="dsa-wordmark">
              <img src="https://timber.mhmcdn.com/site/marketing/icons/DSATeal.svg" alt="DSA logo"/>
              <span>Display</span>
            </div>
            <h1 style={{marginBottom: '10px'}}>Introducing MustHaveMenus Display: </h1>
            <h2>Simplifying Restaurant Marketing by Seamlessly Integrating Display Management with Menu Design</h2>
            <div className="date">February 6, 2024</div>
            <div className="share-links">
              <span>Share this:</span>
              <a href={"https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(sharer)} target="_blank" rel="noreferrer">
                <img src="https://timber.mhmcdn.com/site/marketing/icons/FacebookBlack.svg" alt="Facebook share"/>
              </a>
              <a href={"https://www.linkedin.com/sharing/share-offsite/?url=" + sharer} target="_blank" rel="noreferrer">
                <img src="https://timber.mhmcdn.com/site/marketing/icons/LinkedInBlack.svg" alt="LinkedIn share"/>
              </a>
              <a href={"https://twitter.com/intent/tweet?text=Check out this article! " + sharer} target="_blank" rel="noreferrer">
                <img src="https://timber.mhmcdn.com/site/marketing/icons/TwitterBlack.svg" alt="Twitter share"/>
              </a>
              <span onClick={sendMail}>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/EmailSimple.svg" alt="Email share"/>
              </span>
            </div>
          </div>

          <div className="article-text">
            <p>
              <b>BEND, OR:</b> Today, MustHaveMenus, the all-in-one platform for restaurant marketing, is thrilled to announce the launch of <a href="/feature/digital-menu-board-solution.html">MustHaveMenus Display</a>, a groundbreaking digital display management system that seamlessly integrates with MustHaveMenus' best-in-class menu maker and design tool.
            </p>

            <p>
              This innovative addition gives restaurants a natural link between the creative process and customer touchpoints. When a restaurant makes changes to its brand, menu items or promotions they can be instantly updated on display systems across many screens and locations. Plus, the power of MustHaveMenus' custom design app creates endless potential for engaging multimedia content.
            </p>

            <p>
              <b>Key features of MustHaveMenus Display include:</b>
              <ul>
                <li>Unlimited Creativity: Display works with over 25,000 customizable templates, allowing restaurants to bring any marketing vision to life.</li>
                <li>Seamless Integration: Display effortlessly integrates with the renowned <a href="https://www.musthavemenus.com/feature/menu-maker.html">MustHaveMenus menu maker</a> and design tool.</li>
                <li>Playlists: Display allows users to create unlimited playlists with custom arrangements of content, timing and transitions.</li>
                <li>Instant Updates: Updates made to a design can be instantly published to display screens, eliminating unnecessary steps.</li>
                <li>Custom Schedules: The Display app has advanced scheduling features so that managers can set-and-forget content on their screens.</li>
                <li>Multi-Location Management: The Display app accommodates the needs of small- to medium-sized restaurant chains.</li>
              </ul>
            </p>

            <p>
              MustHaveMenus Display simplifies the way restaurants connect with their customers, making marketing campaigns more efficient and impactful. By seamlessly integrating design capabilities with a versatile distribution system, MustHaveMenus continues to empower the restaurant industry with cutting-edge tools to drive growth and success.
            </p>

            <p>
              <i>"Ever since installing the MustHaveMenus product in our Diner we've seen smiles from local clients!"</i> reported Kevin McMillen, owner of the HandleBar Diner, of Mesa AZ. <i>"Our non-technical business manager at the Diner has taken charge of the entire system and navigates through it with ease. We publish a playlist that shows upcoming events, current menu items and we switch to our “Limited Menu” during big events all with ease now. Having this product fully integrated into our Diner's already established systems was a game changer."</i>
            </p>

            <p>
              <i>"The launch of Display marks a significant milestone for us, as we strive to provide restaurants with a one-stop-shop for all of their in-store marketing,"</i> said Jim Williams, CEO of MustHaveMenus. <i>"We believe this addition empowers restaurants to do more with less. They can create menus and stunning visuals easily and without a graphic designer, then deliver the content to their displays without leaving the program. We want to help them save time while doing great work."</i><br/>
              To learn more about MustHaveMenus Display and how it can transform your restaurant's marketing efforts, please visit <a href="/">www.MustHaveMenus.com</a>, or contact <a href="mailto:support@musthavemenus.com">support@musthavemenus.com</a>.
            </p>

            <p>
              <b>About MustHaveMenus:</b><br/>
              MustHaveMenus is an all-in-one platform for managing in-store restaurant marketing. The company's fully-featured modern design app connects directly with easy delivery tools for digital display, print, QR codes, web, social media and more. With a mission to help restaurants succeed, MustHaveMenus provides time-saving tools and resources to enhance branding, boost customer engagement, and drive revenue.
            </p>
          </div>
        </div>
      </section>
    </main>
  )
}